<template>
  <div>
    <HeaderProfile :img_header="header_image" header="จัดการข้อมูลส่วนตัว"/>
    <ProfileView/>
  </div>
</template>

<script>
import HeaderProfile from "@/components/admin/Profile/headerprofile/HeaderProfile";
import HeaderImage from "@/assets/user.png";
import ProfileView from "@/components/admin/Profile/ProfileView";
export default {
  name: "Profile",
  components: {
    ProfileView,
    HeaderProfile
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
